import React from 'react';
import type { FC, KeyboardEvent, MouseEvent, ReactNode } from 'react';

import { ActivityIndicator } from './activity-indicator';

export enum ButtonType {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
}

export enum ButtonSize {
    SMALL = 'small',
    LARGE = 'large',
}

interface ButtonProps {
    title?: string;
    type?: 'submit' | 'reset' | 'button' | undefined;
    buttonType: ButtonType;
    buttonSize?: ButtonSize;
    disabled?: boolean;
    isLoading?: boolean;
    onClick?: (event?: MouseEvent<HTMLButtonElement> | KeyboardEvent<HTMLButtonElement>) => void;
    leading?: ReactNode;
    trailing?: ReactNode;
    className?: string;
}

export const Button: FC<ButtonProps> = ({
    title,
    buttonType,
    buttonSize,
    leading,
    trailing,
    disabled,
    isLoading,
    onClick,
    type,
    className,
}) => {
    const getButtonBgColor = () => {
        if (disabled || isLoading) {
            return buttonType === ButtonType.PRIMARY ? 'bg-gray-60' : 'bg-transparent';
        }
        return buttonType === ButtonType.PRIMARY ? 'bg-blue hover:bg-blue-80' : 'bg-transparent hover:bg-gray-150';
    };
    const getTextColor = () => {
        if (disabled || isLoading) {
            return buttonType === ButtonType.PRIMARY ? 'text-gray-100' : 'text-gray-110';
        }
        return buttonType === ButtonType.PRIMARY ? 'text-white' : 'text-white';
    };
    const border = `border-solid border-[1px] ${disabled ? 'bg-gray-120' : 'border-gray-100'}`;
    const height = buttonSize === ButtonSize.LARGE ? 'h-10' : 'h-8';
    const paddingX = buttonSize === ButtonSize.LARGE ? 'px-5' : 'px-3.5';

    return (
        <button
            type={type ? type : 'button'}
            disabled={disabled || isLoading}
            className={`flex flex-col-3 ${height} flex-wrap gap-2 justify-center ${getButtonBgColor()} ${getTextColor()} ${buttonType === ButtonType.SECONDARY ? border : ''} 
            ${paddingX} vertical-center items-center rounded-md text-sm font-normal ${disabled === true ? 'opacity-70' : 'opacity-100'} ${className}`}
            onClick={onClick}
            onKeyUp={onClick}
        >
            {!isLoading && leading && leading}
            {isLoading && <ActivityIndicator className="w-4 h-4" />}
            {title && title}
            {trailing && trailing}
        </button>
    );
};
